import { GridRenderCellParams, GridRowId, GridValidRowModel } from '@mui/x-data-grid-pro';
import { DatePicker } from '@mui/x-date-pickers-pro';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { DefaultDataEditGridConfig } from '~/components/DataGridCustom';
import { defaultTextFieldProps } from '~/components/DataGridCustom/common/defaults';

interface DateEditCellProps<R extends GridValidRowModel> extends GridRenderCellParams<R>, DefaultDataEditGridConfig {
  disabled?: boolean;
}

export const DateEditCell = <R extends GridValidRowModel & { id: GridRowId } = { id: GridRowId }>({
  colDef,
  getRowIndex,
  pathPrefix,
  row,
  languageNamespace,
  keyPrefix,
  textFieldProps,
  disabled,
}: DateEditCellProps<R>) => {
  const p = [...(pathPrefix ?? []), getRowIndex?.(row.id), colDef.field];
  const { t: tPrefix } = useTranslation(languageNamespace, { keyPrefix });

  return (
    <Controller
      name={p.join('.')}
      defaultValue={null}
      disabled={disabled}
      render={({ field, fieldState: { error } }) => {
        return (
          <DatePicker
            {...field}
            value={field.value || null}
            slotProps={{
              actionBar: { actions: ['today', 'clear'] },
              openPickerButton: { tabIndex: -1 },
              textField: {
                InputLabelProps: { shrink: true },
                label: tPrefix(colDef.field),
                error: !!error,
                onBlur: field.onBlur,
                ...defaultTextFieldProps,
                ...textFieldProps,
              },
            }}
          />
        );
      }}
    />
  );
};
